<template>
	<div class="setting_container">
		<div class="left_tab">
			<div
				v-for="(item, index) in tablist"
				:key="index"
				@click="active = index"
				class="left_tab_item"
				:class="active === index && 'checked_tab'"
			>
				{{ item.title }}
			</div>
		</div>
		<div v-if="roleType === 'SUPER_ADMIN'" class="right_content">
			<!-- 权限配置 -->
			<div style="height: 100%;" v-if="active == 0">
				<RootSet></RootSet>
			</div>
		</div>
		<div v-else-if="roleType === 'KEFU_ADMIN'" class="right_content">
			<!-- 热门回复 -->
			<div style="height: 100%;" v-if="active == 0">
				<HotReply></HotReply>
			</div>
			<!-- 快捷回复 -->
			<div style="height: 100%;" v-if="active == 1">
				<QuickReply></QuickReply>
			</div>
			<!-- 权限配置 -->
			<div style="height: 100%;" v-if="active == 2">
				<RootSet></RootSet>
			</div>
		</div>
	</div>
</template>

<script setup>
import HotReply from "../../components/HotReply.vue";
import QuickReply from "../../components/QuickReply.vue";
import RootSet from "@/components/RootSet.vue";
import { ref, onMounted } from "vue";
const active = ref(0);
const tablist = ref([]);
const roleType = ref('');

onMounted(() => {
	roleType.value = sessionStorage.userType;
	if (roleType.value === 'SUPER_ADMIN') {
		active.value = 0;
		tablist.value = [
			{
				title: "权限配置",
			},
		]
	} else if (roleType.value === 'KEFU_ADMIN') {
		active.value = 0;
		tablist.value = [
			{
				title: "热门回复",
			},
			{
				title: "快捷回复",
			},
			{
				title: "权限配置",
			},
		]
	}
})
</script>

<style scoped lang="less">
.setting_container {
	width: 100%;
	height: 100%;
	background: #F7F7F7;
	border: 1px #DEDEDE solid;
	border-radius: 4px;
	overflow: hidden;
	display: flex;
	.left_tab {
		height: 100%;
		background: #FFFFFF;
		border-right: 1px solid #DEDEDE;
		.left_tab_item {
			cursor: pointer;
			padding: 24px 67px;
			font-size: 14px;
			color: #4C4C4C;
			background: #FFFFFF;
			transition: all linear 0.5s;
			&:hover {
				background: #F7F7F7;
				color: #4C4C4C;
			}
		}
		.checked_tab {
			background: #F5EEFF;
			color: #A15BFF;
		}
	}
	.right_content {
		flex: 1;
	}
}

</style>
